//angular
import { Component, OnInit, OnDestroy, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import {ActivatedRoute, Event, NavigationStart, Router} from '@angular/router';
//App
import { AppAnimations } from 'src/app/_shared/animations';
import {CheckboxState, PaginatorList, VisibleState} from '../../../../app.data';
import { Filter, RestResponse } from '../../../../_shared/models';
import { GridColumn } from 'src/app/_shared/models/grid.model';
import { DataSharingService, GridService, LoaderService, SkeletonLoaderService } from '../../../../_core/services/index';
import { PanelGridSearchComponent } from '../../_shared/panel-grid-search/panel-grid-search.component';
import { SharedGlobalService } from 'src/app/_core/services/api/shared-global.service';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { MatDialog } from '@angular/material/dialog';
import { KeyName } from 'src/app/app.keynames';
import { DialogConfirmationComponent } from '../dialog/confirmation/confirmation.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  animations: [AppAnimations],
  selector: 'app-grid',
  templateUrl: './grid.component.html'
})

export class GridComponent implements OnInit, OnDestroy {
  collectionOfGridColumn: Array<GridColumn> = [];
  private subs = new Unsubscriber();
  isInternal: boolean = false;
  paginatorList = PaginatorList;

  @Input() gridBulkSection: boolean = true;
  @Input() gridBulkSectionName: string = '';
  @Input() gridBulkCollectionOfActions: Array<string> = [];
  @Input() gridColumnsParam: string;
  @Input() gridDataNotFoundTitle: string = '';
  @Input() gridDataNotFoundDescription: string = '';
  @Input() gridFilter: boolean = true;
  @Input() gridFiltersParam: string = '';
  @Input() gridImport: boolean = false;
  @Input() gridInputSearchPlaceholder: string = 'Search everything';
  @Input() gridPreSetInputText: string = '';
  @Input() gridItemsActions: boolean = true;
  @Input() gridName: string = '';
  @Input() gridSubtitle: string = '';
  @Input() showGridSubtitle: boolean = false;
  @Input() showGridName:  boolean = false;
  @Input() gridPanelPreferences: boolean = true;
  @Input() gridSearch: boolean = false;
  @Input() gridSearchClassMessage: string = 'message';
  @Input() gridSearchNotFoundDescription: string = '';
  @Input() gridSearchNotFoundImage: string = '';
  @Input() gridSearchNotFoundTitle: string = '';
  @Input() sectionMessage: boolean = true;
  @Input() sectionMessageEmpty: boolean = false;
  @Input() importPath: string;
  @Input() panelFiltersSectionId: string = '';
  @Input() panelFiltersGroupDisplayName: string = '';
  @Input() exportCSV = false;
  @Input() exportData = {};
  @Input() gridInternalColumns: Array<string> = [];

  @Output() onGetGridData: EventEmitter<any> = new EventEmitter<any>();
  @Output() actionClicked: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(PanelGridSearchComponent) panelGridSearchComponent: PanelGridSearchComponent;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _router: Router,
    private _sanitizer: DomSanitizer,
    private sharedGlobalService: SharedGlobalService,
    public _skeleton: SkeletonLoaderService,
    public _meta: MetaService,
    public _grid: GridService,
    private shareData: DataSharingService,
    private _dialog: MatDialog,
    private _loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-card', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-card-01.svg'))
    this._iconRegistry.addSvgIcon('ico-clear', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close-menu', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-03.svg'));
    this._iconRegistry.addSvgIcon('ico-delete', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-delete-02.svg'));
    this._iconRegistry.addSvgIcon('ico-drag', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-drag-02.svg'));
    this._iconRegistry.addSvgIcon('ico-filter', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-filter-07.svg'));
    this._iconRegistry.addSvgIcon('ico-import', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-import-02.svg'));
    this._iconRegistry.addSvgIcon('ico-next', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this._iconRegistry.addSvgIcon('ico-new-customer', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-add-01.svg'));
    this._iconRegistry.addSvgIcon('ico-search', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-search-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
    this._iconRegistry.addSvgIcon('ico-export-csv',this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/export-csv.svg'));

    this.subs.addSub = this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (this._grid.statusSnackBar == VisibleState.isVisible) {
          this._grid.closeBulkDialog();
        }
      }
    });
  }

  getGridData(resetPagination: boolean = false) {
    if(resetPagination){
      this._grid.currentPageNumber = 1;
      this._grid.pageIndex = 0;
    }
    this._skeleton.skeletonGridDataLoader = false;
    this.onGetGridData.emit();
  }

  setQueryParametersIfExist() {
    this.route.queryParams.subscribe(params => {
      // Check if the parameters exist and have values
      if (params.itemsPerPage) {
        this._grid.itemsPerPage = parseInt(params.itemsPerPage, 10);
      }
      if (params.page) {
        this._grid.currentPageNumber = parseInt(params.page, 10);
        this._grid.pageIndex = this._grid.currentPageNumber - 1;
      }
      if (params.query) {
        this._grid.searchQuery = params.query;
        this.gridPreSetInputText = this._grid.searchQuery;
      }
      if (params.filterId) {
        this._grid.selectedFilterId = parseInt(params.filterId, 10);
      }
    });
  }

  ngOnInit() {
    this.shareData.getCompany().subscribe(data => {
      if (data.type) {
        this.isInternal = data.type && data.type === 'internal'
      }
    })
    this.shareData.getCompanyPaginator().subscribe(data => {
      if (data.recordsPerPage) {
        this._grid.itemsPerPage = data.recordsPerPage
      }
    })
    this._grid.onGetGridData(this.getGridData.bind(this));
    this._grid.gridItemsActions = this.gridItemsActions;
    this._grid.bulkSectionName = this.gridBulkSectionName;
    this._grid.bulkCollectionOfActions = this.gridBulkCollectionOfActions;

    if (this.gridColumnsParam) {
      //GET Grid columns
      this.subs.addSub = this.sharedGlobalService.getGridColumnsByColumnsParams(this.gridColumnsParam).subscribe(
        (resGridPreferences: RestResponse) => {
          this.collectionOfGridColumn = <Array<GridColumn>>resGridPreferences.data;
          if (!this.isInternal && this.gridInternalColumns.length > 0) {
            this.collectionOfGridColumn = this.collectionOfGridColumn.filter((ele) => !this.gridInternalColumns.includes(ele.keyName));
          }
          //SET Grid columns
          this.subs.addSub = this._meta.setGridColumns(this.collectionOfGridColumn).subscribe(
            (res:any) => {
              //GET filters
              if (this.gridFilter) {
                this.subs.addSub = this.sharedGlobalService.getActiveGridFilters(this.gridFiltersParam).subscribe(
                  (res: RestResponse) => {
                    Object.entries(res.data).forEach(([key, value]) => {
                      if (value.isDefault) {
                        this._grid.selectedFilterId = value.id;
                        this._grid.selectedFilterLabel = value.label;
                      }
                    });
                    this._grid.collectionOfFilter = <Array<Filter>>res.data;
                    if (this._grid.selectedFilterId == 0) {
                      if (this._grid.collectionOfFilter.length > 0){
                        this._grid.selectedFilterId = this._grid.collectionOfFilter[0]?.id;
                        this._grid.selectedFilterLabel = this._grid.collectionOfFilter[0]?.label;
                      } else {
                        this._grid.selectedFilterId = 0;
                        this._grid.selectedFilterLabel = 'Manage Filters';
                      }
                    }
                    this.setQueryParametersIfExist()
                    this.getGridData();
                  },
                  (errFilters: RestResponse) => {
                    this._meta.showNotification(errFilters);
                  }
                );
              } else {
                this.setQueryParametersIfExist()
                this.getGridData();
              }
            },
            (err:any) => {
              console.log(`err. ${err}`);
            }
          )

        },
        (resGridPreferences: RestResponse) => {
          this._meta.showNotification(resGridPreferences);
        }
      );
    }

    this.shareData.actionClicked.subscribe(res=>{
      this.actionClicked.emit(res);
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  setDefaultValues() {
    this.panelGridSearchComponent._elemInputSearch.nativeElement.value = '';
    this._grid.searchQuery = '';
    this._grid.bulkIsChecked = false;
    this._grid.bulkIsIndeterminate = false;
    this._grid.checkedCount = 0;
    this._grid.statusBulkCheckbox = CheckboxState.uncheck;
    this._grid.inputSearchIsVisible = true;
    this._grid.inputSearchIsValid = false;
  }

  export(): void {
    const dialogConfirmation = this._dialog.open(DialogConfirmationComponent, {
      panelClass: ['custom-mat-dialog'],
      data: {
        code: KeyName.export_csv,
      },
    });
    dialogConfirmation.afterClosed().subscribe((resCode) => {
      if (resCode === KeyName.export_csv) {
        const data = {
          section: this.gridName,
          gblFilterId: this._grid.selectedFilterId ? this._grid.selectedFilterId: undefined,
          query: this._grid.searchQuery,
          productId: this.exportData['productId'],
          companyIntegrationId: this.exportData['companyIntegrationId']
        }
        this.sharedGlobalService.exportCSV(data).subscribe((res: RestResponse) => {
            this._loader.stopPageLoader();
            this._meta.showNotification(res);
        },
        (err: any) => {
          this._loader.stopPageLoader();
          this._meta.showNotification(err);
        })
      }
    });
  }
}
